import { CsspOfferGroup } from "./types";

/** Own-stock is a product rule, not a by-city supplier fallback. */
export const CSSP_OWN_STOCK_SUPPLIER_CODE = "kc";

export const CSSP_GROUP_LABELS: Record<CsspOfferGroup, string> = {
  originals: "Искомая запчасть",
  replacements: "Замены",
  analogues: "Аналоги",
};

export const CSSP_GROUP_ORDER: CsspOfferGroup[] = [
  "originals",
  "replacements",
  "analogues",
];

export const CSSP_HISTORY_LIMIT = 6;
